"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchProject = void 0;
var React = require("react");
var Modal = require("react-modal");
var layout_1 = require("../_shared/components/layout");
var inputs_1 = require("../_shared/components/inputs");
require("./SearchProject.scss");
var ProjectActions_1 = require("./ProjectActions");
var react_redux_1 = require("react-redux");
var model_1 = require("../../model");
var FormComponent_1 = require("../_shared/components/inputs/FormComponent");
var constants_1 = require("../../constants");
var classnames_1 = require("classnames");
var _ = require("lodash");
var SearchProject = /** @class */ (function (_super) {
    __extends(SearchProject, _super);
    function SearchProject(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.searchProjects = _.debounce(function (projectName) {
            if (projectName) {
                _this.props.searchProjects(projectName);
            }
            else {
                // If search string is empty, show the projects which are visited by user
                _this.getVisitedProjects();
            }
            _this.setState({ searchString: projectName });
        }, 500);
        _this.state = _this.initialState();
        Modal.setAppElement('#application'); // Avoid readers to read behind it. May set in other place
        return _this;
    }
    SearchProject.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.open && nextProps.open) {
            this.getVisitedProjects();
        }
    };
    SearchProject.prototype.selectProject = function (project) {
        if (!project) {
            return;
        }
        if (this.state.projectSelected && project._id === this.state.projectSelected._id) {
            this.setState({ projectSelected: null });
        }
        else {
            this.setState({ projectSelected: project });
        }
    };
    SearchProject.prototype.selectButtonPressed = function () {
        if (!this.state.projectSelected || !this.state.projectSelected._id) {
            return;
        }
        this.setState(this.initialState());
        this.props.onClose();
        this.props.onProjectSelected(this.state.projectSelected);
    };
    SearchProject.prototype.initialState = function () {
        return { projectSelected: null, subtypeCode: '', searchString: '' };
    };
    SearchProject.prototype.renderProject = function (index, project) {
        var _this = this;
        var currentProjectIsSelected = project && this.state.projectSelected && project._id === this.state.projectSelected._id;
        var currentProjectIsDisabled = project.status === 'DISABLED';
        var projectRowClasses = (0, classnames_1.default)({
            'project-info-row': true,
            'disabled': currentProjectIsDisabled,
            'selected': currentProjectIsSelected,
        });
        return (React.createElement("div", { key: index + ' ' + project._id, className: "project-row" },
            React.createElement(layout_1.Wrapper, { padding: "8px" },
                React.createElement("div", { className: projectRowClasses, onClick: function () { return _this.selectProject(project); } },
                    React.createElement("h1", null,
                        project.clientName,
                        currentProjectIsDisabled && (React.createElement("span", null, "DISABLED"))),
                    React.createElement("div", { className: "margin-8" }),
                    React.createElement("div", { className: "details" },
                        React.createElement("div", { className: "project-info-column" }, project.number),
                        React.createElement("div", { className: "project-info-column-wide" }, project.address),
                        React.createElement("div", { className: "project-info-column" }, project.postcode),
                        React.createElement("div", { className: "project-info-column" }, project.city ? project.city : project.code)),
                    currentProjectIsSelected &&
                        React.createElement("i", { className: "material-icons corner" }, "check_circle")))));
    };
    SearchProject.prototype.searchProject = function () {
        var _this = this;
        var worklogProjects = (0, model_1.getProjectWorkLogsList)(this.props.worklogs);
        // Get the search of the project, or show the default projects
        var projects;
        if (this.state.searchString !== '' || this.props.projects.length) {
            projects = this.props.projects;
        }
        else {
            projects = worklogProjects;
        }
        return (React.createElement(layout_1.Column, { width: "100%" },
            React.createElement("div", { className: "project-results" },
                projects.length === 0 ? React.createElement(layout_1.Center, null,
                    " ",
                    constants_1.NO_DATA_MESSAGE,
                    " ") : null,
                projects.map(function (project, index) { return _this.renderProject(index, project); }))));
    };
    SearchProject.prototype.getVisitedProjects = function () {
        this.props.searchProjects('', this.props.date, this.props.userId);
    };
    SearchProject.prototype.render = function () {
        var _this = this;
        var projectIsSelected = !!this.state.projectSelected && !!this.state.projectSelected._id;
        var selectButtonStyles = (0, classnames_1.default)({
            'button': true,
            'button-disabled': !projectIsSelected,
        });
        return (React.createElement(Modal, { isOpen: this.props.open, className: "search-projects-modal" },
            React.createElement("div", { id: "search-projects-modal-content" },
                React.createElement(inputs_1.SearchInput, { onChange: function (projectName) { return _this.searchProjects(projectName); } }),
                React.createElement("div", { className: "margin-8" }),
                React.createElement("div", { className: "project-list-headers" },
                    React.createElement("div", { className: "project-list-header-item" }, "Nummer"),
                    React.createElement("div", { className: "project-list-header-item-wide" }, "Adres"),
                    React.createElement("div", { className: "project-list-header-item" }, "Postcode"),
                    React.createElement("div", { className: "project-list-header-item" }, "Plaats")),
                React.createElement("div", { id: "search-projects", className: "fullWidth" },
                    this.props.loading && React.createElement("div", { className: "loading" }),
                    !this.props.loading && this.searchProject()),
                React.createElement("div", { className: "margin-8" }),
                React.createElement("div", { className: "buttons-container" },
                    React.createElement("span", { className: selectButtonStyles, onClick: function () {
                            _this.selectButtonPressed();
                        } }, "Selecteer "),
                    React.createElement("div", { className: "margin-8" }),
                    React.createElement("span", { className: "button", onClick: function () {
                            _this.setState(_this.initialState());
                            _this.props.onClose();
                        } }, "Annuleer ")))));
    };
    return SearchProject;
}(FormComponent_1.default));
exports.SearchProject = SearchProject;
var mapStateToProps = function (_) {
    return {
        projects: _.reducer.projectsReducer.projects,
        loading: _.reducer.projectsReducer.loading,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    searchProjects: function (filterName, date, userId) {
        return ProjectActions_1.ProjectActions.searchProjects(filterName, date, userId)(dispatch);
    },
}); };
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(SearchProject);
